import { Identity } from "@sdbn/appclient";

export class LinkTransportDetails {

    id: number;
    carrier: string;
    name: string;
    identifier: string;
    transportScope: string;
    timeframeDate: string;
    timeframe: number;

    linkableTransports = new Array<LinkableTransport>();
}

export class LinkableTransport {
    id: number;
    carrier: string;
    cargo: string;
    planningDate: string;
    planningDateSortValue: number;
    timeframeDate: string;
    timeframe: number;
}

export class TransportLinkage {

    targetTransport: Identity;
    linkedTransports = new Array<Identity>();
    timeframe: number;
}

export class LinkVehicleWithTransport {

    vehicleId: number;
    transportId: number;

}
